import { ContentLayout } from '../../ui/shared/components/layout/ContentLayout';
import { PublicContentRouteList } from '../content/ContentRouteList';

export const PublicContentRouteLayout = () => (
    <ContentLayout>
        <PublicContentRouteList />
    </ContentLayout>
);
